import { COLORS } from '@btime/constants'
import React from 'react'

import Tag from '../../../components/presentation/Tag'

const LevelTag = ({ level, ...props }) => {
  let color = COLORS.blue
  if (level === 'error') color = COLORS.red
  if (level === 'warn') color = COLORS.yellow
  if (level === 'debug') color = COLORS.dark2
  if (level === 'monitor') color = COLORS.dark3
  return <Tag label={level.toUpperCase()} color={color} size="xxsmall" {...props} />
}

export default LevelTag
